module.exports = __webpack_public_path__ + "img/yidong.580fe9be.png";